export const mappedAllCustomer = ({ ...rest }) => ({
  label: rest.nome || '',
  value: rest.id,
  ...rest,
})
